import { useContext, useEffect, useState } from 'react';
import AttToken from '../../../helpers/attToken';
import { useLocation, useParams } from 'react-router-dom';
import Checklists from '../../../service/Checklists';
import { FormToFilling, SubItemFormFilling } from '../../Filling/Types';
import { trackEventMatomo } from '../../../helpers/matomo';
import CircularProgress, {
  CircularProgressProps,
} from '@mui/material/CircularProgress';
import Anonimo from '../../../service/Anonimo';
import { toast } from 'react-toastify';
import { Player } from '@lottiefiles/react-lottie-player';
import CheckFilling from '../CheckFilling';
import NewFormFillingHeader from './NewFormFillingHeader';
import NewFormFillingFooter from './NewFormFillingFooter';
import SubItemFilling from './SubItemFilling';
import { Drawer, Stack, TextField, Typography } from '@mui/material';
import DrawerList from './DrawerList';
import { Paragraph } from '../../Notifications/style/SingleNotificationStyle';
import { WebFormContext } from '../../../context/WebFormContext';
import QueryFn from '../../../helpers/QueryFn';

const checkListService = new Checklists();
const anonimoService = new Anonimo();
const queryFn = new QueryFn();
const dateTime = Date.now();
const TIMEOUTDURATION = 4000;

export default function NewFormFilling({ form, openExecution }: { form?: FormToFilling, openExecution?: boolean }) {
  const { setWebForm, webForm } = useContext(WebFormContext);
  const [firstRender, setFirstRender] = useState(true);
  const [onStartScreen, setOnStartScreen] = useState(false);
  const { search } = useLocation();
  const [inicio] = useState<number>(dateTime);
  const [completed, setCompleted] = useState(false);
  const [itemToShow, setItemToShow] = useState<number>(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (window.location.pathname.includes('/preenchedor') || openExecution) {
      (() => {
        const body = document.getElementById('root');
        if (body) {
          body.style.backgroundColor = '#E5E5E5';
          body.style.margin = '0';
          body.style.padding = '0';
          body.style.height = '100%';
        }
      })();
    } else {
      (() => {
        const body = document.getElementById('root');
        if (body) {
          body.style.backgroundColor = '#4a4a4a;';
        }
      })();
    }
  }, []);

  const { formId } = useParams();

  const { data, isLoading } = queryFn.useFetch(
    'GET_FORM_DATA',
    async () => {
      try {
        const token = await AttToken();
        if ((token || window.location.pathname.includes('/preenchedor')) && formId) {
          const response = await checkListService.getChecklistForWebFilling(token || null, formId, true);
          if (response.styleOptions && response.styleOptions.enablePostMessage) {
            setOnStartScreen(true);
          }
          return response;
        }
      } catch (error) {
        console.error('Erro ao buscar dados do formulário:', error);
      }
    }
  );

  useEffect(() => {
    if (firstRender) {
      if (form) {
        setWebForm(form);
        setFirstRender(false);
      } else if (data) {
        setWebForm(data.formToFilling);
        setFirstRender(false);
      }
    }
  }, [form, data, firstRender, setWebForm]);

  useEffect(() => {
    if (data) {
      if (!data?.styleOptions?.assocatedChecklists?.includes(data.formToFilling.id)) {
        delete data.styleOptions;
      }
    }
  }, []);

  const { mutate, isPending, isSuccess, isError } = queryFn.useMutate('EXECUTE_FORM',
    async () => {
      try {
        toast.warn('Executando formulário, aguarde...');
        const params = decodeURIComponent(search).replace(/[?]/g, '').replace(/[ ]/g, '_').replace(/[=]/g, '/').split('&');
        await anonimoService.executaChecklistAnonimo({
          ...data.formToFilling,
          id: data.formToFilling.id,
          inicio: inicio,
          fim: new Date().getMilliseconds()
        },
          params || []);
      } catch (error) {
        console.error('Erro ao executar formulário:', error);
        throw error; // Re-throw the error to be caught by the mutation's onError handler
      }
    }
  );

  useEffect(() => {
    if (isError) {
      toast.error('Erro ao executar formulário');
    }
  }, [isError]);

  useEffect(() => {
    if (isSuccess) {
      setCompleted(true);
      toast.success('Formulário executado!');
    }
  }, [isSuccess]);

  useEffect(() => {
    if (completed && data.styleOptions?.enableLoop) {
      setTimeout(() => {
        if (data.styleOptions.enablePostMessage) {
          setOnStartScreen(true);
        }
        setCompleted(false);
      }, TIMEOUTDURATION);
    }
    if (completed && data.styleOptions?.enableRedirect && data.styleOptions.link) {
      setTimeout(() => {
        window.open(data.styleOptions.link);
      }, TIMEOUTDURATION);
    }
  }, [completed, isLoading]);

  if (completed && data.styleOptions?.enablePosMessage) {
    return (
      <div className='postMessageDiv' style={{ padding: '5% 10% 5% 10%' }}>
        {data.styleOptions.imageAfter && (
          <img style={{ maxWidth: '20%' }} src={data.styleOptions.imageAfter} alt="aaa" />
        )}
        <TextField
          type='text'
          inputProps={{
            min: 0, style: { textAlign: 'center' }
          }}
          disabled
          fullWidth
          multiline
          value={data.styleOptions.messageAfter}
        />
      </div>
    );
  }

  if (completed && !data.styleOptions?.enablePosMessage) {
    return (
      <div className='enableMessage'>
        <Player
          src="https://lottie.host/79da71c7-a35b-4581-be5a-cd7aa5e4f644/UGaGhP6cDm.json"
          className="player"
          autoplay
          keepLastFrame
        />
      </div>
    );
  }

  const scrollToElement = (id: string) => {
    setTimeout(() => {
      const elemento = document.getElementsByClassName(id) as any;
      if (elemento) {
        elemento[0].style.border = '1px solid red';
        elemento[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 999);
  };

  function onClick() {
    const result = CheckFilling(data.formToFilling);
    if (!result.success) {
      scrollToElement(`${result.itemId}|${result.subItemId}`);
      toast.error(`Subitem
          ${result.subItem?.toUpperCase()}\n, 
          no item ${result.item?.toUpperCase()}\n 
          ${result.texto}`, {
        position: "top-right",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setItemToShow(Number(result.itemId?.slice(-1)));
    } if (result.success) {
      mutate('');
    }
  }

  if (onStartScreen && !isLoading && data?.styleOptions) {
    return (
      <div className='postMessageDiv' style={{ padding: '5% 10% 5% 10%' }}>
        {data.styleOptions.imageBefore && (
          <img style={{ maxWidth: '20%' }} src={data?.styleOptions?.imageBefore} alt="aaa" />
        )}
        <TextField
          onClick={() => trackEventMatomo('preenchimento', 'click', 'textarea', 'edita valor')}
          type='text'
          inputProps={{
            min: 0, style: { textAlign: 'center' }
          }}
          disabled
          fullWidth
          multiline
          value={data?.styleOptions?.messageBefore}
        />
        <button type="button" className="button is-success" onClick={() => setOnStartScreen(false)}>Prosseguir</button>
      </div>
    );
  }

  function Loading(props: CircularProgressProps) {
    return (
      <Stack
        sx={{ height: '100svh' }}
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#e01cd5" />
              <stop offset="100%" stopColor="#1CB5E0" />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} />
        <Typography variant='h4'>Carregando...</Typography>
      </Stack>
    );
  }

  if (isLoading) {
    return (
      <Loading />
    );
  }

  if (!webForm) {
    return (
      <Stack
        sx={{ height: '100svh' }}
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Typography variant='h4'>FORMULARIO NAO ENCONTRADO</Typography>
      </Stack>
    );
  }

  return (
    <Stack
      sx={{ backgroundColor: '#E5E5E5' }}
      width={'100%'}
      direction="column"
    >
      <NewFormFillingHeader
        setOpen={setOpen}
        styleOptions={data && data?.styleOptions}
        formName={webForm?.nome as string}
      />
      <Drawer open={open} onClose={() => setOpen(false)}>
        {<DrawerList
          itens={webForm?.itens}
          setOpen={setOpen}
          setItemToShow={setItemToShow}
        />}
      </Drawer>
      {itemToShow !== null
        && <Stack
          sx={{
            width: '100%',
            p: `${window.navigator.maxTouchPoints <= 0
              ? '5% 10% 15% 10%'
              : '5% 2% 25% 2%'}`,
            height: '100%'
          }}
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Stack width={'100%'}>
            {webForm && webForm?.itens[itemToShow]?.subitens?.some((ele: any) => ele.obrigatoriedade?.preenchimento && !ele.checked)
              && <Paragraph> (*) Preenchimento Obrigatório  </Paragraph>
            }
            <Typography variant='h5'>Item - {webForm && webForm?.itens[itemToShow]?.nome}</Typography>
          </Stack>
          {webForm && webForm?.itens[itemToShow].subitens?.map((ele: SubItemFormFilling) => (
            <Stack
              width={'100%'}
              key={`Item:${ele.itemid}|Subitem:${ele.id}`}
              direction="column"
              justifyContent="space-between"
            >
              <SubItemFilling subItem={ele} />
            </Stack>
          ))}
        </Stack>}
      {!form
        && <NewFormFillingFooter
          itemToShow={itemToShow}
          setItemToShow={setItemToShow}
          isLoading={isPending}
          executa={onClick}
          checklist={webForm}
          styleOptions={data && data.styleOptions}
          chamadosConfig={data && data.chamadosConfig}
          onlyOneItem={webForm && webForm.itens.length <= 1}
        />}
    </Stack>
  );
}